const NewAreaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
    >
      <path
        d="M13.4166 17H18.2083V12H16.2916V15H13.4166V17ZM4.79163 12H6.70829V9H9.58329V7H4.79163V12ZM3.83329 20C3.30621 20 2.85499 19.8042 2.47965 19.4125C2.1043 19.0208 1.91663 18.55 1.91663 18V6C1.91663 5.45 2.1043 4.97917 2.47965 4.5875C2.85499 4.19583 3.30621 4 3.83329 4H19.1666C19.6937 4 20.1449 4.19583 20.5203 4.5875C20.8956 4.97917 21.0833 5.45 21.0833 6V18C21.0833 18.55 20.8956 19.0208 20.5203 19.4125C20.1449 19.8042 19.6937 20 19.1666 20H3.83329ZM3.83329 18H19.1666V6H3.83329V18Z"
        fill="#828FA1"
      />
    </svg>
  );
};

export default NewAreaIcon;
